import { AssetStorageKeyWordDTO } from './../../../../../../base/models/models.swagger.generated';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { DialogComponent as SyncfusionDialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { AssetStorageAddKeyWordFormType } from './assetStorageAddKeyWordFormType';
import { AssetKeyWordService } from '../asset-key-word-service/asset-key-word.service';
import { TranslateModule } from '@ngx-translate/core';
import { AppErrorMessagesComponent } from '../../../../../../base/error-messages/app-error-messages.component';

@Component({
    selector: 'app-asset-storage-add-key-word-dialog',
    templateUrl: './asset-storage-add-key-word-dialog.component.html',
    styleUrls: ['./asset-storage-add-key-word-dialog.component.scss'],
    imports: [DialogModule, ReactiveFormsModule, AppErrorMessagesComponent, TranslateModule]
})
export class AssetStorageAddKeyWordDialogComponent implements OnInit {

  @ViewChild('addKeyWordDialog') dialog: SyncfusionDialogComponent;

  @Output()
  public keyWordAdded: EventEmitter<AssetStorageKeyWordDTO> = new EventEmitter<AssetStorageKeyWordDTO>();

  public assetStorageAddKeyWordForm : FormGroup<AssetStorageAddKeyWordFormType>;

  constructor(
    private fb: FormBuilder,
    private assetKeyWordService: AssetKeyWordService,
  ) { }

  ngOnInit(): void {
    this.assetStorageAddKeyWordForm = this.fb.group<AssetStorageAddKeyWordFormType>({
      id: this.fb.control<number>(0),
      name: this.fb.control<string>(null, [Validators.required]),
    });
  }

  public resetDialog(): void {
    this.assetStorageAddKeyWordForm.setValue({
      id: 0,
      name: null,
    });
    this.assetStorageAddKeyWordForm.markAsUntouched();
    this.assetStorageAddKeyWordForm.markAsPristine();
    this.assetStorageAddKeyWordForm.updateValueAndValidity();
  }

  public showDialog(): void {
    this.dialog.show();
  }

  public onSaveKeyWord() {
    this.assetStorageAddKeyWordForm.updateValueAndValidity();
    if (this.assetStorageAddKeyWordForm.valid) {
      this.assetKeyWordService.addRecord(this.createDto()).subscribe((res) => {
        this.keyWordAdded.emit(res);
        this.closeDialog();
      });
    }
  }

  public closeDialog() {
    this.dialog.hide();
    this.resetDialog();
  }

  private createDto (): AssetStorageKeyWordDTO {
    return {
      id: this.assetStorageAddKeyWordForm.value.id,
      name: this.assetStorageAddKeyWordForm.value.name,
    } as AssetStorageKeyWordDTO;
  }
}
